import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { useUpdateHubspotPlaylist } from '../../hubspotPlaylistQueries';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { H2 } from 'foundations-components/transitional/components/H2';
import { H4 } from 'foundations-components/transitional/components/H4';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const UpdateError = () => /*#__PURE__*/_jsx(Alert, {
  type: "danger",
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.playlists.hubspotPlaylists.publishUnpublish.error"
  })
});
const UnpublishModal = ({
  onClose,
  playlist
}) => {
  const [unpublishMessage, setUnpublishMessage] = useState('');
  const onUnpublishComplete = () => {
    FloatingAlertStore.addAlert({
      message: I18n.text('learningCenter.playlists.hubspotPlaylists.publishUnpublish.unpublishSuccess'),
      type: 'success'
    });
    onClose();
  };
  const {
    updateHubspotPlaylist,
    updateHubspotPlaylistLoading,
    updateHubspotPlaylistError
  } = useUpdateHubspotPlaylist({
    playlistId: playlist.id,
    onCompleted: onUnpublishComplete
  });
  const handleUnpublishClick = async () => {
    try {
      await updateHubspotPlaylist({
        variables: {
          playlistId: playlist.id,
          active: false
        }
      });
    } catch (error) {
      void error;
    }
  };
  return /*#__PURE__*/_jsxs(Modal, {
    use: "danger",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlists.hubspotPlaylists.publishUnpublish.unpublishModalHeading"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [updateHubspotPlaylistLoading && /*#__PURE__*/_jsx(LoadingSpinner, {
        grow: true
      }), updateHubspotPlaylistError && /*#__PURE__*/_jsx(UpdateError, {}), !updateHubspotPlaylistLoading && !updateHubspotPlaylistError && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.playlists.hubspotPlaylists.publishUnpublish.unpublishModalBody"
          })
        }), /*#__PURE__*/_jsx(FormControl, {
          label: "Type the message to unpublish",
          children: /*#__PURE__*/_jsx(TextInput, {
            onChange: e => setUnpublishMessage(e.target.value),
            placeholder: "UNPUBLISH"
          })
        })]
      })]
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        disabled: unpublishMessage.toUpperCase() !== 'UNPUBLISH' || updateHubspotPlaylistLoading,
        onClick: () => {
          void handleUnpublishClick();
        },
        use: "danger",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlists.hubspotPlaylists.publishUnpublish.unpublishModalConfirmButton"
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: onClose,
        use: "tertiary-light",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.common.cancel"
        })
      })]
    })]
  });
};
const PublishModal = ({
  onClose,
  playlist
}) => {
  const onPublishComplete = () => {
    FloatingAlertStore.addAlert({
      message: I18n.text('learningCenter.playlists.hubspotPlaylists.publishUnpublish.publishSuccess'),
      type: 'success'
    });
    onClose();
  };
  const {
    updateHubspotPlaylist,
    updateHubspotPlaylistLoading,
    updateHubspotPlaylistError
  } = useUpdateHubspotPlaylist({
    playlistId: playlist.id,
    onCompleted: onPublishComplete
  });
  const handleConfirmClick = async () => {
    try {
      await updateHubspotPlaylist({
        variables: {
          playlistId: playlist.id,
          active: true
        }
      });
    } catch (error) {
      void error;
    }
  };
  return /*#__PURE__*/_jsxs(Modal, {
    children: [/*#__PURE__*/_jsxs(DialogBody, {
      children: [updateHubspotPlaylistLoading && /*#__PURE__*/_jsx(LoadingSpinner, {
        grow: true
      }), updateHubspotPlaylistError && /*#__PURE__*/_jsx(UpdateError, {}), !updateHubspotPlaylistLoading && !updateHubspotPlaylistError && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(H4, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.playlists.hubspotPlaylists.publishUnpublish.publishModalHeading"
          })
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlists.hubspotPlaylists.publishUnpublish.publishModalBody"
        })]
      })]
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        disabled: updateHubspotPlaylistLoading,
        onClick: () => {
          void handleConfirmClick();
        },
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlists.hubspotPlaylists.publishUnpublish.publishModalConfirmButton"
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: onClose,
        use: "tertiary-light",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.common.cancel"
        })
      })]
    })]
  });
};
export const HubspotPlaylistPublishUnpublishSwitch = ({
  playlist
}) => {
  const [unpublishModalOpen, setUnpublishModalOpen] = useState(false);
  const [publishModalOpen, setPublishModalOpen] = useState(false);
  const handleToggleClick = () => {
    if (playlist.active) {
      setUnpublishModalOpen(true);
    } else {
      setPublishModalOpen(true);
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Toggle, {
      checked: playlist.active,
      onClick: handleToggleClick,
      textChecked: "Published",
      textUnchecked: "Unpublished"
    }), unpublishModalOpen && /*#__PURE__*/_jsx(UnpublishModal, {
      onClose: () => setUnpublishModalOpen(false),
      playlist: playlist
    }), publishModalOpen && /*#__PURE__*/_jsx(PublishModal, {
      onClose: () => setPublishModalOpen(false),
      playlist: playlist
    })]
  });
};
export default HubspotPlaylistPublishUnpublishSwitch;